exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modal-select-techs/modal-select-techs.component.css
// module id = ./src/app/modal-select-techs/modal-select-techs.component.css
// module chunks = main